<app-navigation></app-navigation>
<router-outlet></router-outlet>
<app-footer></app-footer>
